import { ButtonWrapper } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated (date: 09.11.2021) */

var Looks;

(function (Looks) {
  Looks["PRIMARY"] = "primary";
  Looks["SECONDARY"] = "secondary";
})(Looks || (Looks = {}));

var defaultProps = {
  look: "primary",
  onClick: function onClick() {
    /* empty */
  },
  htmlAttrs: {}
};

var Button = function Button(props) {
  return /*#__PURE__*/createElement(ButtonWrapper, Object.assign({}, props));
};

Button.defaultProps = defaultProps;
Button.Looks = Looks;
Button.displayName = "Button";

export { Button, Looks };
